export default __webpack_public_path__ + "static/media/LogoRegioneAMP.5ce55497.png";